<div class="spinner-container" *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
</div>
<div
    class="panel-flex"
    [ngStyle]="{ visibility: isLoading ? 'hidden' : 'visible' }"
>
    <app-dashboard-panel-header
        [title]="title"
        [isPreview]="isPreview"
        (onDeleteClicked)="handleDeleteClicked()"
    ></app-dashboard-panel-header>

    <div style="margin-bottom: 10px">
        <app-channel-table-header-compact> </app-channel-table-header-compact>
    </div>

    <div class="main-content" #tableBody>
        <app-ops-table-body
            [isLoading]="isLoading"
            [loadingTemplateRows]="itemsPerPage"
        >
            <app-channel-table-row-compact
                *ngFor="let channel of channels | slice: pageStart : pageEnd"
                [channel]="channel"
                (click)="handleChannelSelected(channel)"
            ></app-channel-table-row-compact>
        </app-ops-table-body>
    </div>

    <div class="bottom-ribbon">
        <div>
            <button data-cy="dashboard-channel-group-tab-go-to-page-button" (click)="handleGoToPageClicked()" class="primary caption">
                {{ "dashboard.panel.labels.navigate-to-page" | translate }}
            </button>
        </div>
        <div>
            <app-page-list
                [pages]="pageCount"
                [displayedPageLimit]="displayedPageNumber()"
                [(currentPage)]="currentPage"
            ></app-page-list>
        </div>
    </div>
</div>
